<template>
	<CardGrafico
		v-if="!reportMode"
		:title="$t('stemProportion')"
		:subtitle="subtitle"
	>
		<template #botoes>
			<div v-show="!reportMode">
				<ButtonDropdown
					v-model="dropdownDownload"
					style="margin-top: 0.5rem"
					color="trv-neutral"
					:label="$t('download')"
					semantic-class="mini"
					:options="[
						{ label: 'PNG', value: 'image/png' },
						{ label: 'JPEG', value: 'image/jpeg' },
						{ label: 'PDF', value: 'application/pdf' },
						{ label: 'SVG', value: 'image/svg+xml' },
						// { label: '.csv', value: 'text/csv' },
					]"
					outlined
				/>
			</div>
		</template>
		<template #grafico>
			<Loading v-if="Object.keys(data).length === 0" />
			<div
				v-else
				class="container__graficofazenda"
			>
				<Chart
					ref="ref__chart"
					:options="chartOptions"
				/>
			</div>
		</template>
	</CardGrafico>
	<Chart
		v-else
		ref="ref__chart"
		style="width: 40vw"
		:options="chartOptions"
	/>
</template>

<script>
import { Chart } from 'highcharts-vue'
import ButtonDropdown from '../../../../components/ButtonDropdown/ButtonDropdown'
import CardGrafico from '../../CardGrafico/CardGrafico'
import Loading from '../../../../components/Loading/Loading'

import { getColorHexByCSSVariable } from '../../../../utils/themesHelper'

export default {
	components: { ButtonDropdown, CardGrafico, Chart, Loading },

	props: {
		/**
		 * Diz para o componente que ele está sendo utilizado em relatórios, assim
		 * é possível ocultar elementos de tela que demandam ação do usuário
		 */
		reportMode: {
			type: Boolean,
			default: false,
		},
		/**
		 * Dados que devem ir para o grafico
		 */
		data: { type: Object, required: true },

		/**
		 * Data do ultimo processamento como subtitulo
		 */
		subtitle: { type: String, required: true },
	},

	data() {
		return {
			dropdownDownload: '',
			chartOptions: {
				/**
				 * Creditos no canto inferior direito do grafico
				 */
				credits: {
					enabled: false,
				},
				exporting: {
					enabled: false,
				},
				chart: {
					type: 'pie',
				},
				title: {
					text: this.reportMode ? this.subtitle : '',
				},
				tooltip: {
					enabled: false,
				},
				accessibility: {
					point: {
						valueSuffix: '%',
					},
				},
				plotOptions: {
					pie: {
						dataLabels: {
							formatter: function () {
								return `
                  <div class="container__pie__datalabel">
                    <span>${this.key}</span>
                    <span>${this.percentage.toFixed(2)}%</span>
                  </div>
                `
							},
							useHTML: true,
						},
					},
				},
				series: [
					{
						size: '80%',
						innerSize: '75%',
						data: [],
					},
				],
				responsive: {
					rules: [
						{
							condition: {
								maxWidth: 500,
							},
							chartOptions: {
								series: [
									{
										size: '80%',
										innerSize: '90%',
									},
								],
							},
						},
					],
				},
			},
		}
	},

	watch: {
		/**
		 * Atualiza o grafico sempre que a propriedade data e alterada
		 */
		data() {
			this.setHighchartsOptions()
			return {
				/**
				 * Opção selecionada para o download
				 */
				dropdownDownload: '',
			}
		},

		/**
		 * Seleciona a opcao de download escolhida
		 */
		dropdownDownload(type) {
			if (type) {
				const filename = `${new Date().getTime()}`
				if (type === 'text/csv') {
					const csv = this.$refs.ref__chart.chart.getCSV()
					stringToExportCSV(filename, csv)
				} else {
					this.$refs.ref__chart.chart.exportChart({ filename, type })
				}
				this.dropdownDownload = ''
			}
		},
	},

	methods: {
		/**
		 * Seta os dados do grafico
		 */
		setHighchartsOptions() {
			const rgbDefaultColor = getColorHexByCSSVariable('--color-default')
			const rgbPrimaryColor = getColorHexByCSSVariable('--color-primary')

			const data = [
				{
					name: this.$t('useful'),
					y: this.data.totalDeArvoresUteis,
					color: rgbDefaultColor,
				},
				{
					name: this.$t('lost'),
					y: this.data.totalDeArvoresNaoUteis,
					color: rgbPrimaryColor,
				},
			]

			this.chartOptions.series[0].data = data
		},
	},
}
</script>

<style scoped>
@import url('../../../../css/PieHighcharts.css');
.container__graficofazenda {
	display: grid;
}
</style>
